<template>
  <div class="llp-calendar">
    <CalendarPrime
      :id="id"
      ref="calendar"
      v-model="componentModel"
      :class="[{ 'border border-danger': errors.length > 0 }, classNames]"
      :dateFormat="dateFormat"
      :disabled="disabled"
      :iconDisplay="iconDisplay"
      :maxDate="maxDate"
      :minDate="minDate"
      :showButtonBar="showButtonBar"
      :showIcon="showIcon"
      :selectionMode="selectionMode"
      @show="() => $emit('show')"
      @date-select="onSelect"
      @update:modelValue="newValue => $emit('update:modelValue', newValue)"
    />
    <span v-if="errors.length === 1" class="text-danger">
      {{ errors[0].$message }}
    </span>
    <ul v-else-if="errors.length > 1" class="m-0">
      <li v-for="error in errors" :key="error.$uid" class="text-danger">
        <span class="text-danger">{{ error.$message }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BaseCalendar",
  props: {
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Object, Array, String, Date],
      default: null,
    },
    classNames: {
      type: String,
      default: "w-100",
    },
    iconDisplay: {
      type: String,
      default: "input",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showButtonBar: {
      type: Boolean,
      default: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    dateFormat: {
      type: String,
      default: "dd/mm/yy",
    },
    selectionMode: {
      type: String,
      default: "single", // or 'range'
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "show", "dateSelect"],
  data() {
    return {
      componentModel: this.modelValue,
    };
  },
  watch: {
    modelValue: {
      handler(newValue) {
        this.componentModel = newValue;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onSelect() {
      if (this.selectionMode === "range" && Array.isArray(this.componentModel)) {
        const [start, end] = this.componentModel;
        if (start && end && this.autoClose) {
          this.$emit("dateSelect", this.componentModel);
          this.$refs.calendar.overlayVisible = false;
        }
      } else if (this.autoClose) {
        this.$emit("dateSelect", this.componentModel);
        this.$refs.calendar.overlayVisible = false;
      }
    },
  },
};
</script>
